// src/pages/micuenta/DatosPersonales.jsx
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import {
  FaArrowLeft,
  FaUser,
  FaBriefcase,
  FaGraduationCap,
  FaLightbulb,
  FaGavel,
} from "react-icons/fa";
import "./datospersonales.css";

function DatosPersonales() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  // Si el usuario no se ha cargado aún
  if (!user) {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Cargando usuario...</h2>
        </div>
      </div>
    );
  }

  // Al hacer click, siempre navega a "/mi-cuenta"
  const handleBack = () => {
    navigate("/mi-cuenta");
  };

  return (
    <div className="register-container">
      <div className="register-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        {/* Sección: Datos Generales */}
        <div className="section-container">
          <h2 className="account-section-title">
            <FaUser className="section-icon" /> Datos Generales
          </h2>
          <div className="account-info-list">
            <p>
              <strong>Nombre:</strong> {user.nombre}
            </p>
            <p>
              <strong>Apellido:</strong> {user.apellido}
            </p>
            {user.userType === "employer" && (
              <>
                <p>
                  <strong>Nombre Empresa:</strong> {user.nombreEmpresa || "No especificado"}
                </p>
                <p>
                  <strong>Puesto:</strong> {user.puestoEmpresa || "No especificado"}
                </p>
              </>
            )}
            <p>
              <strong>Correo Electrónico:</strong> {user.email}
            </p>
          </div>
        </div>

        {/* Sección: Empleo */}
        <div className="section-container">
          <h2 className="account-section-title">
            <FaBriefcase className="section-icon" /> Empleo
          </h2>
          <div className="datos-section">
            <div className="datos-row-view">
              <strong>Industria de interés:</strong> {user.empleoIndustria || "No especificado"}
            </div>
            <div className="datos-row-view">
              <strong>Años de experiencia:</strong> {user.empleoAnios || "No especificado"}
            </div>
            <div className="datos-row-view">
              <strong>Status migratorio:</strong> {user.empleoStatus || "No especificado"}
            </div>
          </div>
        </div>

        {/* Sección: Educación */}
        <div className="section-container">
          <h2 className="account-section-title">
            <FaGraduationCap className="section-icon" /> Educación
          </h2>
          <div className="datos-section">
            <div className="datos-row-view">
              <strong>Nivel de escolaridad:</strong> {user.eduNivel || "No especificado"}
            </div>
            <div className="datos-row-view">
              <strong>Nivel de inglés:</strong> {user.eduIngles || "No especificado"}
            </div>
            <div className="datos-row-view">
              <strong>Validación de credenciales:</strong> {user.eduCredenciales || "No especificado"}
            </div>
          </div>
        </div>

        {/* Sección: Emprendimiento */}
        <div className="section-container">
          <h2 className="account-section-title">
            <FaLightbulb className="section-icon" /> Emprendimiento
          </h2>
          <div className="datos-section">
            <div className="datos-row-view">
              <strong>Industria de interés:</strong> {user.empIndustria || "No especificado"}
            </div>
            <div className="datos-row-view">
              <strong>Años de experiencia:</strong> {user.empAnios || "No especificado"}
            </div>
            <div className="datos-row-view">
              <strong>Asistencia técnica:</strong> {user.empAsistencia || "No especificado"}
            </div>
            <div className="datos-row-view">
              <strong>Hubs de emprendedores:</strong> {user.empHubs || "No especificado"}
            </div>
          </div>
        </div>

        {/* Sección: Migración */}
        <div className="section-container">
          <h2 className="account-section-title">
            <FaGavel className="section-icon" /> Migración
          </h2>
          <div className="datos-section">
            <div className="datos-row-view">
              <strong>Abogados autorizados (DOJ):</strong> {user.migAbogados || "No especificado"}
            </div>
          </div>
        </div>

        {/* Botón para editar datos */}
        <div className="datos-actions">
          <button className="datos-edit-btn" onClick={() => alert("Implementa la edición de datos personales")}>
            Editar Datos Personales
          </button>
        </div>
      </div>
    </div>
  );
}

export default DatosPersonales;